import { TenantEntity } from '../TenantEntity'
import { checkBillAddress } from '@/api/partner/mailingAddress'
/**
 * Base class for 收发通(BillAddress)
 *
 */
export class BillAddress extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get consigneeCode() {
    return this._data.consigneeCode
  }
  set consigneeCode(consigneeCode) {
    this._data.consigneeCode = consigneeCode
  }
  get consigneeLine1() {
    return this._data.consigneeLine1
  }
  set consigneeLine1(consigneeLine1) {
    this._data.consigneeLine1 = consigneeLine1
  }
  get consigneeLine2() {
    return this._data.consigneeLine2
  }
  set consigneeLine2(consigneeLine2) {
    this._data.consigneeLine2 = consigneeLine2
  }
  get consigneeLine3() {
    return this._data.consigneeLine3
  }
  set consigneeLine3(consigneeLine3) {
    this._data.consigneeLine3 = consigneeLine3
  }
  get consigneeLine4() {
    return this._data.consigneeLine4
  }
  set consigneeLine4(consigneeLine4) {
    this._data.consigneeLine4 = consigneeLine4
  }
  get consigneeLine5() {
    return this._data.consigneeLine5
  }
  set consigneeLine5(consigneeLine5) {
    this._data.consigneeLine5 = consigneeLine5
  }
  get consigneeLine6() {
    return this._data.consigneeLine6
  }
  set consigneeLine6(consigneeLine6) {
    this._data.consigneeLine6 = consigneeLine6
  }
  get consigneeLine7() {
    return this._data.consigneeLine7
  }
  set consigneeLine7(consigneeLine7) {
    this._data.consigneeLine7 = consigneeLine7
  }
  get lastUsed() {
    return this._data.lastUsed
  }
  set lastUsed(lastUsed) {
    this._data.lastUsed = lastUsed
  }
  get lob() {
    return this._data.lob
  }
  set lob(lob) {
    this._data.lob = lob
  }
  get notifyCode() {
    return this._data.notifyCode
  }
  set notifyCode(notifyCode) {
    this._data.notifyCode = notifyCode
  }
  get notifyLine1() {
    return this._data.notifyLine1
  }
  set notifyLine1(notifyLine1) {
    this._data.notifyLine1 = notifyLine1
  }
  get notifyLine2() {
    return this._data.notifyLine2
  }
  set notifyLine2(notifyLine2) {
    this._data.notifyLine2 = notifyLine2
  }
  get notifyLine3() {
    return this._data.notifyLine3
  }
  set notifyLine3(notifyLine3) {
    this._data.notifyLine3 = notifyLine3
  }
  get notifyLine4() {
    return this._data.notifyLine4
  }
  set notifyLine4(notifyLine4) {
    this._data.notifyLine4 = notifyLine4
  }
  get notifyLine5() {
    return this._data.notifyLine5
  }
  set notifyLine5(notifyLine5) {
    this._data.notifyLine5 = notifyLine5
  }
  get notifyLine6() {
    return this._data.notifyLine6
  }
  set notifyLine6(notifyLine6) {
    this._data.notifyLine6 = notifyLine6
  }
  get officeId() {
    return this._data.officeId
  }
  set officeId(officeId) {
    this._data.officeId = officeId
  }
  get partnerId() {
    return this._data.partnerId
  }
  set partnerId(partnerId) {
    this._data.partnerId = partnerId
  }
  get pod() {
    return this._data.pod
  }
  set pod(pod) {
    this._data.pod = pod
  }
  get shipperCode() {
    return this._data.shipperCode
  }
  set shipperCode(shipperCode) {
    this._data.shipperCode = shipperCode
  }
  get shipperLine1() {
    return this._data.shipperLine1
  }
  set shipperLine1(shipperLine1) {
    this._data.shipperLine1 = shipperLine1
  }
  get shipperLine2() {
    return this._data.shipperLine2
  }
  set shipperLine2(shipperLine2) {
    this._data.shipperLine2 = shipperLine2
  }
  get shipperLine3() {
    return this._data.shipperLine3
  }
  set shipperLine3(shipperLine3) {
    this._data.shipperLine3 = shipperLine3
  }
  get shipperLine4() {
    return this._data.shipperLine4
  }
  set shipperLine4(shipperLine4) {
    this._data.shipperLine4 = shipperLine4
  }
  get shipperLine5() {
    return this._data.shipperLine5
  }
  set shipperLine5(shipperLine5) {
    this._data.shipperLine5 = shipperLine5
  }
  get shipperLine6() {
    return this._data.shipperLine6
  }
  set shipperLine6(shipperLine6) {
    this._data.shipperLine6 = shipperLine6
  }
  get shipperLine7() {
    return this._data.shipperLine7
  }
  set shipperLine7(shipperLine7) {
    this._data.shipperLine7 = shipperLine7
  }
  get instructBill() {
    return this._data.instructBill
  }
  set instructBill(instructBill) {
    this._data.instructBill = instructBill
  }
  get consigneeShortCode() {
    return this._data.consigneeShortCode
  }
  set consigneeShortCode(consigneeShortCode) {
    this._data.consigneeShortCode = consigneeShortCode
  }
  get consigneeEnterpriseCode() {
    return this._data.consigneeEnterpriseCode
  }
  set consigneeEnterpriseCode(consigneeEnterpriseCode) {
    this._data.consigneeEnterpriseCode = consigneeEnterpriseCode
  }
  get consigneeEnterpriseName() {
    return this._data.consigneeEnterpriseName
  }
  set consigneeEnterpriseName(consigneeEnterpriseName) {
    this._data.consigneeEnterpriseName = consigneeEnterpriseName
  }
  get consigneeAddress() {
    return this._data.consigneeAddress
  }
  set consigneeAddress(consigneeAddress) {
    this._data.consigneeAddress = consigneeAddress
  }
  get consigneeContactsType() {
    return this._data.consigneeContactsType
  }
  set consigneeContactsType(consigneeContactsType) {
    this._data.consigneeContactsType = consigneeContactsType
  }
  get consigneeContacts() {
    return this._data.consigneeContacts
  }
  set consigneeContacts(consigneeContacts) {
    this._data.consigneeContacts = consigneeContacts
  }
  get consigneeCityName() {
    return this._data.consigneeCityName
  }
  set consigneeCityName(consigneeCityName) {
    this._data.consigneeCityName = consigneeCityName
  }
  get consigneeProvinceCode() {
    return this._data.consigneeProvinceCode
  }
  set consigneeProvinceCode(consigneeProvinceCode) {
    this._data.consigneeProvinceCode = consigneeProvinceCode
  }
  get consigneeProvinceName() {
    return this._data.consigneeProvinceName
  }
  set consigneeProvinceName(consigneeProvinceName) {
    this._data.consigneeProvinceName = consigneeProvinceName
  }
  get consigneeZipCode() {
    return this._data.consigneeZipCode
  }
  set consigneeZipCode(consigneeZipCode) {
    this._data.consigneeZipCode = consigneeZipCode
  }
  get consigneeCountryCode() {
    return this._data.consigneeCountryCode
  }
  set consigneeCountryCode(consigneeCountryCode) {
    this._data.consigneeCountryCode = consigneeCountryCode
  }
  get consigneeAeoEnterpriseCode() {
    return this._data.consigneeAeoEnterpriseCode
  }
  set consigneeAeoEnterpriseCode(consigneeAeoEnterpriseCode) {
    this._data.consigneeAeoEnterpriseCode = consigneeAeoEnterpriseCode
  }
  get consigneeSpecificContactsName() {
    return this._data.consigneeSpecificContactsName
  }
  set consigneeSpecificContactsName(consigneeSpecificContactsName) {
    this._data.consigneeSpecificContactsName = consigneeSpecificContactsName
  }
  get notifyLine7() {
    return this._data.notifyLine7
  }
  set notifyLine7(notifyLine7) {
    this._data.notifyLine7 = notifyLine7
  }
  get notifyShortCode() {
    return this._data.notifyShortCode
  }
  set notifyShortCode(notifyShortCode) {
    this._data.notifyShortCode = notifyShortCode
  }
  get notifyEnterpriseCode() {
    return this._data.notifyEnterpriseCode
  }
  set notifyEnterpriseCode(notifyEnterpriseCode) {
    this._data.notifyEnterpriseCode = notifyEnterpriseCode
  }
  get notifyEnterpriseName() {
    return this._data.notifyEnterpriseName
  }
  set notifyEnterpriseName(notifyEnterpriseName) {
    this._data.notifyEnterpriseName = notifyEnterpriseName
  }
  get notifyAddress() {
    return this._data.notifyAddress
  }
  set notifyAddress(notifyAddress) {
    this._data.notifyAddress = notifyAddress
  }
  get shipperShortCode() {
    return this._data.shipperShortCode
  }
  set shipperShortCode(shipperShortCode) {
    this._data.shipperShortCode = shipperShortCode
  }
  get shipperEnterpriseCode() {
    return this._data.shipperEnterpriseCode
  }
  set shipperEnterpriseCode(shipperEnterpriseCode) {
    this._data.shipperEnterpriseCode = shipperEnterpriseCode
  }
  get shipperEnterpriseName() {
    return this._data.shipperEnterpriseName
  }
  set shipperEnterpriseName(shipperEnterpriseName) {
    this._data.shipperEnterpriseName = shipperEnterpriseName
  }
  get shipperAddress() {
    return this._data.shipperAddress
  }
  set shipperAddress(shipperAddress) {
    this._data.shipperAddress = shipperAddress
  }
  get shipperContactsType() {
    return this._data.shipperContactsType
  }
  set shipperContactsType(shipperContactsType) {
    this._data.shipperContactsType = shipperContactsType
  }
  get shipperContacts() {
    return this._data.shipperContacts
  }
  set shipperContacts(shipperContacts) {
    this._data.shipperContacts = shipperContacts
  }
  get shipperCityName() {
    return this._data.shipperCityName
  }
  set shipperCityName(shipperCityName) {
    this._data.shipperCityName = shipperCityName
  }
  get shipperProvinceCode() {
    return this._data.shipperProvinceCode
  }
  set shipperProvinceCode(shipperProvinceCode) {
    this._data.shipperProvinceCode = shipperProvinceCode
  }
  get shipperProvinceName() {
    return this._data.shipperProvinceName
  }
  set shipperProvinceName(shipperProvinceName) {
    this._data.shipperProvinceName = shipperProvinceName
  }
  get shipperZipCode() {
    return this._data.shipperZipCode
  }
  set shipperZipCode(shipperZipCode) {
    this._data.shipperZipCode = shipperZipCode
  }
  get shipperCountryCode() {
    return this._data.shipperCountryCode
  }
  set shipperCountryCode(shipperCountryCode) {
    this._data.shipperCountryCode = shipperCountryCode
  }
  get shipperAeoEnterpriseCode() {
    return this._data.shipperAeoEnterpriseCode
  }
  set shipperAeoEnterpriseCode(shipperAeoEnterpriseCode) {
    this._data.shipperAeoEnterpriseCode = shipperAeoEnterpriseCode
  }
  get consigneeSpecificContactsType() {
    return this._data.consigneeSpecificContactsType
  }
  set consigneeSpecificContactsType(consigneeSpecificContactsType) {
    this._data.consigneeSpecificContactsType = consigneeSpecificContactsType
  }
  get consigneeSpecificContacts() {
    return this._data.consigneeSpecificContacts
  }
  set consigneeSpecificContacts(consigneeSpecificContacts) {
    this._data.consigneeSpecificContacts = consigneeSpecificContacts
  }
  get notifyContactsType() {
    return this._data.notifyContactsType
  }
  set notifyContactsType(notifyContactsType) {
    this._data.notifyContactsType = notifyContactsType
  }
  get notifyContacts() {
    return this._data.notifyContacts
  }
  set notifyContacts(notifyContacts) {
    this._data.notifyContacts = notifyContacts
  }
  get notifyCityName() {
    return this._data.notifyCityName
  }
  set notifyCityName(notifyCityName) {
    this._data.notifyCityName = notifyCityName
  }
  get notifyProvinceCode() {
    return this._data.notifyProvinceCode
  }
  set notifyProvinceCode(notifyProvinceCode) {
    this._data.notifyProvinceCode = notifyProvinceCode
  }
  get notifyProvinceName() {
    return this._data.notifyProvinceName
  }
  set notifyProvinceName(notifyProvinceName) {
    this._data.notifyProvinceName = notifyProvinceName
  }
  get notifyZipCode() {
    return this._data.notifyZipCode
  }
  set notifyZipCode(notifyZipCode) {
    this._data.notifyZipCode = notifyZipCode
  }
  get notifyCountryCode() {
    return this._data.notifyCountryCode
  }
  set notifyCountryCode(notifyCountryCode) {
    this._data.notifyCountryCode = notifyCountryCode
  }
  get notifyAeoEnterpriseCode() {
    return this._data.notifyAeoEnterpriseCode
  }
  set notifyAeoEnterpriseCode(notifyAeoEnterpriseCode) {
    this._data.notifyAeoEnterpriseCode = notifyAeoEnterpriseCode
  }
  get billHistoryType() {
    return this._data.billHistoryType
  }
  set billHistoryType(billHistoryType) {
    this._data.billHistoryType = billHistoryType
  }

  static checkBillAddress(addr) {
    return checkBillAddress(addr)
  }
}
